import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  Avatar,
  AULA_AVATAR_BG_COLOUR,
  Box,
  Card,
  Text,
  useTheme,
} from '@ublend-npm/aulaui-core';
import { currentUser } from '@core/selectors/user';
import { getHomeUserFirstName } from '@app/selectors/home';

const getTimeOfDayGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
};

const HomeGreeting = () => {
  const { palette } = useTheme();
  const user = useSelector(currentUser);
  const firstName = useSelector(getHomeUserFirstName);
  const greeting = getTimeOfDayGreeting();
  const todayLabel = moment().format('[Today is] Do MMMM YYYY');
  const initials = [user?.firstName?.[0], user?.lastName?.[0]]
    .filter(Boolean)
    .join('')
    .toUpperCase();

  return (
    <Card
      sx={{
        borderRadius: '0.75rem',
        padding: '1.5rem',
        boxShadow: 'none',
        border: `1px solid ${palette.divider}`,
      }}
    >
      <Box display="flex" alignItems="center" gap="1rem">
        <Avatar
          src={user?.avatar}
          fallbackText={initials || '?'}
          sx={{
            width: 48,
            height: 48,
            backgroundColor: AULA_AVATAR_BG_COLOUR,
            color: palette.common.white,
          }}
        />
        <Box>
          <Text fontSize="1.5rem" fontWeight={600} color="text.primary">
            {greeting}, {firstName}
          </Text>
          <Text fontSize="0.875rem" color="text.secondary" mt={0.5}>
            {todayLabel}
          </Text>
        </Box>
      </Box>
    </Card>
  );
};

export default HomeGreeting;
